export default __webpack_public_path__ + "static/media/retriever-app-icon.eff6e50b.svg";